import React, { FC } from "react";

import { ContentBox } from "ui-library/layouts";

import i18n from "core/i18n";
import { max50Characters, upperLettersNumbers } from "core/form";
import { Field } from "core/hookForm";

import { VehicleCancellationFormValues } from "../../types";

type AccountSectionSkProps = {
    sectionName: "fundsTransferBankAccount";
};

export const AccountSectionSk: FC<AccountSectionSkProps> = ({ sectionName }) => {
    const { t } = i18n.useTranslation();
    return (
        <>
            <ContentBox fullWidth>
                <Field<VehicleCancellationFormValues>
                    name={`${sectionName}.iban`}
                    label={t("investments.sellSwitch.targetAccountIban")}
                    input="textField"
                    normalize={[upperLettersNumbers, max50Characters]}
                />
            </ContentBox>
        </>
    );
};
